import Call from "./call";

const Api = () => {
	var setUrl = (path) => {
		return new Call(path);
	};

	var setMailUrl = (path) => {
		return new Call(path, true);
	};

	return {
		server_url: setUrl(),
		ping: setUrl(""),
		training: setUrl("/trainings"),
		programs: setUrl("/programs"),
		quotations: setUrl("/requests"),
		conferenceRegistration: setUrl("/conference-registrations"),
		trainingRegistration: setUrl("/training-registrations"),
		trainingGalleries: setUrl("/training-galleries"),
		conferenceGalleries: setUrl("/conference-galleries"),
		conferenceGuests: setUrl("/conference-guests"),
		conferences: setUrl("/conferences"),
		packages: setUrl("/sponsor-packages"),
		conferenceFees: setUrl("/conference-fees"),
		news: setUrl("/news-articles"),
		categories: setUrl("/program-categories"),
		services: setUrl("/service"),
		testimonials: setUrl("/testimonials"),
		documents: setUrl("/documents"),
		newsletter: setUrl("/newsletters"),
		events: setUrl("/events"),
		contactform: setUrl("/contactforms"),
		about: setUrl("/about"),
		mentorship: setUrl("/mentorship"),
		abstracts: setUrl("/abstracts"),
		headlines: setUrl("/headlines"),
		sendemail: setMailUrl("/sendemail"),
		workshopRegistration: setUrl("/workshop-registrations"),
		statistics: setUrl("/statistics"),
		distributors: setUrl("/distributors"),
	};
};

export default Api();
